module.exports = __webpack_public_path__ + "media/images/honeyfarm/farm_eight-3e185e31ceccb168e4e1ec372bd688f7.jpg";